
import { Options, Vue } from 'vue-class-component';
import { useStore, Store } from 'vuex';
import { useRouter, Router } from 'vue-router';

export default class RaceFooter extends Vue {}
